export class NespressoElement extends HTMLElement {
    constructor() {
        super()
        this.template = ''
    }

    connectedCallback() {
        this.props = this._createProps()
        this.onStart?.()
        this.loadTemplate()
        this.onReady?.()
    }

    /**
     * Load the attributes and create the props object
     * @returns {any}
     * @private
     */
    _createProps(forceAttributes = null) {
        const attributes = forceAttributes || this.attributes

        const getData = attr => attr.find(attribute => attribute.nodeName === 'data')

        let props
        try {
            props = [...attributes].reduce((all, attr) => {
                return { ...all, [attr.nodeName]: attr.nodeValue }
            }, {})

            const data = getData([...attributes])

            if (data === undefined || data === null) {
                return props
            }

            return { ...props, ...JSON.parse(data.nodeValue) }
        } catch (error) {
            console.log(this.nodeName, 'ERROR: No data', error)
        }
    }

    /**
     * Render by DOM diff
     */
    render(force = false) {
        if (force) {
            // todo review the performance of this
            this.innerHTML = ''
        }
        /**
         * Convert a template string into HTML DOM nodes
         * @param  {String} str The template string
         * @return {Node}       The template HTML
         */
        const _stringToHTML = str => {
            const parser = new DOMParser()
            const doc = parser.parseFromString(str, 'text/html')
            return doc.body
        }

        /**
         * Compare the template to the UI and make updates
         * @param  {Node} template The template HTML
         * @param  {Node} elem     The UI HTML
         */
        const _diff = (template, elem) => {
            /**
             * Get the type for a node
             * @param  {Node}   node The node
             * @return {String}      The type
             */
            const _getNodeType = node => {
                if (node.nodeType === 3) {
                    return 'text'
                }
                if (node.nodeType === 8) {
                    return 'comment'
                }
                return node.tagName.toLowerCase()
            }

            /**
             * Get the content from a node
             * @param  {Node}   node The node
             * @return {String}      The type
             */
            const _getNodeContent = node => {
                if (node.childNodes && node.childNodes.length > 0) {
                    return null
                }
                return node.textContent
            }

            // Get arrays of child nodes
            const domNodes = Array.prototype.slice.call(elem.childNodes)
            const templateNodes = Array.prototype.slice.call(template.childNodes)

            // If extra elements in DOM, remove them
            var count = domNodes.length - templateNodes.length
            if (count > 0) {
                for (; count > 0; count--) {
                    domNodes[domNodes.length - count].parentNode.removeChild(
                        domNodes[domNodes.length - count]
                    )
                }
            }

            // Diff each item in the templateNodes
            templateNodes.forEach(function (node, index) {
                // If element doesn't exist, create it
                if (!domNodes[index]) {
                    elem.appendChild(node.cloneNode(true))
                    return
                }

                // If element is not the same type, replace it with new element
                if (_getNodeType(node) !== _getNodeType(domNodes[index])) {
                    domNodes[index].parentNode.replaceChild(node.cloneNode(true), domNodes[index])
                    return
                }

                // If content is different, update it
                const templateContent = _getNodeContent(node)
                if (templateContent && templateContent !== _getNodeContent(domNodes[index])) {
                    domNodes[index].textContent = templateContent
                }

                // If target element should be empty, wipe it
                if (domNodes[index].childNodes.length > 0 && node.childNodes.length < 1) {
                    domNodes[index].innerHTML = ''
                    return
                }

                // If element is empty and shouldn't be, build it up
                // This uses a document fragment to minimize reflows
                if (domNodes[index].childNodes.length < 1 && node.childNodes.length > 0) {
                    const fragment = document.createDocumentFragment()
                    _diff(node, fragment)
                    domNodes[index].appendChild(fragment)
                    return
                }

                // If there are existing child elements that need to be modified, diff them
                if (node.childNodes.length > 0) {
                    _diff(node, domNodes[index])
                }
            })
        }

        // todo - add support to reactivity
        // this.template(this.state)
        const templateHTML = _stringToHTML(this.template)
        _diff(templateHTML, this)
    }

    /**
     * Set the HTML to be used in the template
     * @param {String} html The HTML to use
     *
     * This function is overwritten by the extended class to set the HTML
     *
     */
    loadTemplate(template = '', force = false) {
        this.template = template === '' ? this.template : `${template}`
        this.render(force)
    }

    disconnectedCallback() {
        this.onDestroy?.()
    }
}

customElements.get('nb-nespresso-element') ||
    customElements.define('nb-nespresso-element', NespressoElement)
